import * as z from 'zod';

/** Payload for the order offers visualization modal. */
export const orderOffersPayloadSchema = z.object({
  orderId: z.union([z.string(), z.number()]),
});
export type OrderOffersPayload = z.infer<typeof orderOffersPayloadSchema>;
